import { reportMemberLink } from '../utils.js';
export const departmentLink = reportMemberLink('departments.id', '/admin/departments/:id');
export const legislativeItemLink = reportMemberLink('legislative_items.id', '/legislative-items/:id');
export const meetingBodyLink = reportMemberLink('meeting_bodies.id', '/admin/meeting-bodies/:id');
export const meetingLink = reportMemberLink('meetings.id', '/meetings/:id');
export const meetingViewershipLink = reportMemberLink('meeting_viewership.id', '/meetings/:id');
export const minutesTrackerLink = reportMemberLink('minutes_tracker.id', '/meetings/:id');
export const stepAssignedMeetingBodyLink = reportMemberLink('step_assigned_meeting_bodies.id', '/admin/meeting-bodies/:id');
export const userLink = reportMemberLink('users.id', '/admin/users/:id');
